const SITE_URL = "https://coursepress.lnu.se";
const PATH_PREFIX = "/manual";

const config = {
  gatsby: {
    pathPrefix: PATH_PREFIX,
    siteUrl: SITE_URL,
    gaTrackingId: null,
  },
  header: {
    logoLink: "/",
    title: "logo-wordmark-en.png",
    courseName: "Manuals and guides for various topics",
    links: [{ text: "", link: "" }],
  },
  sidebar: {
    frontline: false,
    ignoreIndex: true,
    startCollapsed: true,
  },
  siteMetadata: {
    title: "Linnaeus University",
    language: "en",
    description: "Documentation built with mdx.",
    ogImage: null,
  },
};

module.exports = config;
